import React, { Component } from 'react'
import Container from '@mui/material/Container'
import CssBaseline from '@mui/material/CssBaseline'
import Typography from '@mui/material/Typography'
import { Button } from '@mui/material'
import Slide from '@mui/material/Slide'
import { Player, BigPlayButton } from 'video-react'

// Components
import HeadGlobal from './headerGlobal'

// Utils
import {
  welcomeEs,
  welcomeFr,
  welcomeEn,
  welcomePtg,
} from '../textApp/textTrad'
import { navigationGA } from '../data/GA'
// IMAGES
import reebokImg from '../assets/images/reebokW.png'
import nikeImg from '../assets/images/nikeW.png'
import samsungImg from '../assets/images/samsung.png'
import appleImg from '../assets/images/apple_W.png'

// VIDEO ENGLISH
import reebokEn from '../assets/videos/reebok_stimuli.mp4'
import reebokEnMov from '../assets/videos/reebok_stimuli_phone.mp4'
import nikeEn from '../assets/videos/nike_stimuli.mp4'
import nikeEnMov from '../assets/videos/nike_stimuli_phone.mp4'
import appleEn from '../assets/videos/apple_stimuli.mp4'
import appleEnMov from '../assets/videos/apple_stimuli_phone.mp4'
import samsungEn from '../assets/videos/samsung_stimuli.mp4'
import samsungEnMov from '../assets/videos/samsung_stimuli_phone.mp4'

// VIDEOS FRENCH
import reebokFr from '../assets/videos/reebok_stimuli_fr.mp4'
import reebokFrMov from '../assets/videos/reebok_stimuli_fr_phone.mp4'
import nikeFr from '../assets/videos/nike_stimuli_fr.mp4'
import nikeFrMov from '../assets/videos/nike_stimuli_fr_phone.mp4'
import appleFr from '../assets/videos/apple_stimuli_fr.mp4'
import appleFrMov from '../assets/videos/apple_stimuli_fr_phone.mp4'
import samsungFr from '../assets/videos/samsung_stimuli_fr.mp4'
import samsungFrMov from '../assets/videos/samsung_stimuli_fr_phone.mp4'

// VIDEOS SPANISH
import reebokEs from '../assets/videos/reebok_stimuli_es.mp4'
import reebokEsMov from '../assets/videos/reebok_stimuli_es_phone.mp4'
import nikeEs from '../assets/videos/nike_stimuli_es.mp4'
import nikeEsMov from '../assets/videos/nike_stimuli_es_phone.mp4'
import appleEs from '../assets/videos/apple_stimuli_es.mp4'
import appleEsMov from '../assets/videos/apple_stimuli_es_phone.mp4'
import samsungEs from '../assets/videos/samsung_stimuli_es.mp4'
import samsungEsMov from '../assets/videos/samsung_stimuli_es_phone.mp4'

const smallDevice = window.matchMedia('(max-width: 576px)').matches
class Stimuli extends Component {
  constructor(props) {
    super(props)

    this.state = {
      brand: this.props.brand,
      watched: false,
      loaded: 0,
    }
    this.continue = this.continue.bind(this)
    this.selectVid = this.selectVid.bind(this)
    this.selectImg = this.selectImg.bind(this)
    this.selectLangVid = this.selectLangVid.bind(this)
  }

  componentDidMount() {
    // subscribe state change
    this.player.subscribeToStateChange(this.handleStateChange.bind(this))
    // Google Analytcs Page View
    navigationGA('Video Stimuli', 'video', 'video')
  }

  selectLang = () => {
    const { lng } = this.props
    switch (lng) {
      case 'es':
        return welcomeEs
      case 'fr':
        return welcomeFr
      case 'en':
        return welcomeEn
      case 'pt':
        return welcomePtg
      default:
        return welcomeEn
    }
  }
  // Funcion to GET time of video
  handleStateChange(state) {
    // copy player state to this component's state
    this.setState({
      player: state,
      watched: state.ended,
    })
    // Redirect to new page after ended video
    if (state.ended && this.state.watched) {
      setTimeout(() => this.continue(), 7000)
    }
  }
  // Funcion to redirect to next page video
  continue = () => {
    const { ended } = this.state.player
    const { navigate, location } = this.props
    if (ended) {
      navigate('/survey' + location.search)
    }
  }

  // Function to organize the list of videos and languages
  selectLangVid = () => {
    const { lng } = this.props
    switch (lng) {
      case 'es':
        return {
          mobile: {
            reebok: reebokEsMov,
            nike: nikeEsMov,
            apple: appleEsMov,
            samsung: samsungEsMov,
          },
          desk: {
            reebok: reebokEs,
            nike: nikeEs,
            apple: appleEs,
            samsung: samsungEs,
          },
        }
      case 'fr':
        return {
          mobile: {
            reebok: reebokFrMov,
            nike: nikeFrMov,
            apple: appleFrMov,
            samsung: samsungFrMov,
          },
          desk: {
            reebok: reebokFr,
            nike: nikeFr,
            apple: appleFr,
            samsung: samsungFr,
          },
        }
      case 'en':
        return {
          mobile: {
            reebok: reebokEnMov,
            nike: nikeEnMov,
            apple: appleEnMov,
            samsung: samsungEnMov,
          },
          desk: {
            reebok: reebokEn,
            nike: nikeEn,
            apple: appleEn,
            samsung: samsungEn,
          },
        }
      default:
        return {
          mobile: {
            reebok: reebokEnMov,
            nike: nikeEnMov,
            apple: appleEnMov,
            samsung: samsungEnMov,
          },
          desk: {
            reebok: reebokEn,
            nike: nikeEn,
            apple: appleEn,
            samsung: samsungEn,
          },
        }
    }
  }
  // Funcntion to return video
  selectVid = () => {
    const { brand } = this.props
    const vids = this.selectLangVid()
    switch (brand) {
      case 'reebok':
        const video1 = smallDevice ? vids.mobile.reebok : vids.desk.reebok
        return video1
      case 'nike':
        const video2 = smallDevice ? vids.mobile.nike : vids.desk.nike
        return video2
      case 'apple':
        const video3 = smallDevice ? vids.mobile.apple : vids.desk.apple
        return video3
      case 'samsung':
        const video4 = smallDevice ? vids.mobile.samsung : vids.desk.samsung
        return video4
      default:
        const video5 = smallDevice ? vids.mobile.nike : vids.desk.nike
        return video5
    }
  }
  // Function to return brand image
  selectImg = () => {
    const { brand } = this.props
    switch (brand) {
      case 'reebok':
        return reebokImg
      case 'nike':
        return nikeImg
      case 'apple':
        return appleImg
      case 'samsung':
        return samsungImg
      default:
        return nikeImg
    }
  }
  render() {
    const video = this.selectVid()
    const imaged = this.selectImg()
    const brand = this.props.brand.toUpperCase()
    const { setlang } = this.props
    const { watched } = this.state
    const txt = this.selectLang()
    return (
      <div className='center'>
        <div className='main videoComp'>
          <CssBaseline>
            <HeadGlobal setlang={setlang} changeLang={true} />
          </CssBaseline>
          <Typography
            component='h1'
            variant='h4'
            align='center'
            sx={{
              fontWeight: '600',
              paddingBottom: '1vh',
              fontSize: {
                xs: '1rem',
                sm: '1.5rem',
                md: '1.5rem',
              },
            }}
          >
            {txt.vidTxt1} {brand} {txt.vidTxt2}
          </Typography>
          <Slide
            direction='right'
            in={true}
            mountOnEnter
            unmountOnExit
            timeout={700}
          >
            <Container
              sx={{
                // height: '50vh',
                width: {
                  xs: '90vw',
                  sm: '85vw',
                  md: '50vw',
                },
                display: 'grid',
              }}
            >
              <Player
                ref={(player) => {
                  this.player = player
                }}
                playsInline
                poster={imaged}
                src={video}
                height={'100%'}
                // autoPlay
              >
                <BigPlayButton position='center' />
              </Player>
            </Container>
          </Slide>
          {watched && (
            <Slide
              direction='down'
              in={true}
              mountOnEnter
              unmountOnExit
              timeout={700}
            >
              <Button
                onClick={this.continue}
                variant='contained'
                sx={{
                  marginTop: '2vh',
                  padding: {
                    xs: '1rem 4rem',
                    sm: '1rem 2rem',
                    md: '0.5rem 2rem',
                  },
                  fontSize: {
                    xs: '1.2rem',
                    sm: '1.3rem',
                    md: '1.3rem',
                  },
                }}
              >
                {txt.cont}
              </Button>
            </Slide>
          )}
        </div>
      </div>
    )
  }
}
export default Stimuli
